//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Builder.js";
import "../Motion/Motion.BodyContactAdams.js";
import "../no/SelectNXObject.js";
import "../Motion/Motion.BodyContactLms.js";
import "../Motion/Motion.BodyContactRecurdyn.js";
import "../Motion/Motion.SelectLink.js";
import "../Motion/Motion.BodyContactSphereToCAD.js";
import "../no/SelectObject.js";
let d=[[[1,"AdamsParameters",0,"Motion.BodyContactAdams",0],[0,"ContactType",1,0],[1,"FirstContactGeometryObject",0,"SelectNXObject",0],[0,"FirstContactGeometryObjectOvrCtrl",1,0],[1,"LmsParameters",0,"Motion.BodyContactLms",0],[0,"Name",1,0],[1,"RecurdynParameters",0,"Motion.BodyContactRecurdyn",0],[1,"SecondContactGeometryObject",0,"SelectNXObject",0],[0,"SecondContactGeometryObjectOvrCtrl",1,0],[0,"SphereCenter",1,"Point",0],[0,"SphereCenterOvrCtrl",1,0],[1,"SphereLink",0,"Motion.SelectLink",0],[0,"SphereLinkOvrCtrl",1,0],[1,"SphereToCadParameters",0,"Motion.BodyContactSphereToCAD",0]],[],[]];
SPLM.Motion.BodyContactBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.BodyContactBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.BodyContactBuilder.ContactTypeOption = Object.freeze({
    "CADToCADContact" : "CADToCADContact", "SphereToCADContact" : "SphereToCADContact"});

export default SPLM;